






















































import { faBan } from '@fortawesome/free-solid-svg-icons'
import { CLASSIFIED_SEARCH_ACTIONS_NS } from '~/store/modules/shared/classifieds/search/actions/state'
import { mapActions, mapState } from 'vuex'
import DiscountsService from '~/services/admin/discounts/DiscountsService'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    CFormError
  },
  props: {
    classifiedId: {
      validator: prop => typeof prop === 'string' || typeof prop === 'number',
      required: true
    },
    classifiedTitle: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      days: 1,
      icons: {
        ban: faBan
      }
    }
  },
  computed: {
    ...mapState(CLASSIFIED_SEARCH_ACTIONS_NS, {
      actionPending: state => state.pending
    }),
    daysValid() {
      return this.days >= 1
    }
  },
  methods: {
    ...mapActions(CLASSIFIED_SEARCH_ACTIONS_NS, {
      performAction: 'performAction'
    }),
    showModal() {
      this.$refs.disableClassifiedModal.show()
    },
    hideModal() {
      this.$refs.disableClassifiedModal.hide()
    },
    disableClassified() {
      this.performAction({
        action: () => {
          const discountsService = this.$dep(DiscountsService)
          return discountsService.disableClassified(
            this.classifiedId,
            this.days
          )
        },
        classifiedId: this.classifiedId
      })
      this.hideModal()
    }
  }
})
